import styles from './total-report.module.scss';
import { useState } from 'react';
import { useCourseTableHook } from '../../../requestUtils';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { ValueFormatterParams } from 'ag-grid-community';
import { CreateHeaders, ErrorButton, HeaderSizeEnum, PrimaryButton, currencyHeader, textHeader, dateHeader, SuccessButton } from '@frontend-workspace/react-shared-lib';
import SendCertificateDialog from './send-certificate-dialog/send-certificate-dialog';
import { IRegistrationPeriod } from '../../../_models/registration-period';
import TotalReportSkeleton from './total-report-skeleton';
import { endOfMonth, startOfMonth } from 'date-fns';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface TotalReportProps { }

export function TotalReport(props: TotalReportProps) {
  const { data: registrationsInPeriod, isLoading, dateRange, onDateChange } = useCourseTableHook<IRegistrationPeriod>(`course/registrations/inPeriode`, { startDate: startOfMonth(new Date()), endDate: endOfMonth(new Date()) });

  const { t } = useTranslation();
  const [sendCertificate, setSendCertificate] = useState<IRegistrationPeriod | undefined>(undefined);

  const openSendCertificateDialog = (e: any) => setSendCertificate(e.data);
  const closeSendCertificateDialog = () => setSendCertificate(undefined);

  const sendRenderer = (params: ValueFormatterParams) => {
    const hasSentCertificate = params.data.hasSentCertificate;
    const hasAnsweredSurvey = params.data.hasAnsweredSurvey;
    const text = hasSentCertificate ? t('totalReport.sendCourseCertificateAgain') : t('totalReport.sendCourseCertificate');
    return (
      hasAnsweredSurvey ? <SuccessButton
        variant="contained"
        onClick={() => openSendCertificateDialog(params)}
        size='small'>
        {text}
      </SuccessButton> : <ErrorButton
        variant="contained"
        onClick={() => openSendCertificateDialog(params)}
        size='small'>
        {text}
      </ErrorButton>
    );
  };

  const showRenderer = (params: ValueFormatterParams) => {
    const handleShowCertificate = () => {
      fetch(`https://surveyserver.azurewebsites.net/surveys/certificate/courseId/${params.data.courseId}/respondantId/${params.data.email}`).then(result => result.blob())
        .then(result => {
          const file = new Blob([result], { type: "application/pdf" });
          window.open(URL.createObjectURL(file), '_blank');
        })
    }
    return (
      <PrimaryButton
        variant="contained"
        onClick={handleShowCertificate}
        size='small'>
        {t('totalReport.showCourseCertificate')}
      </PrimaryButton>
    );
  };

  return (<>
    {isLoading ? <TotalReportSkeleton /> :
      <WebkuaTable
        data={registrationsInPeriod}
        dateRange={dateRange}
        supportFutureDates={true}
        onSetDateRange={onDateChange}
        headers={CreateHeaders([
          dateHeader("registeredDateString", t('totalReport.dateOfOrder')),
          dateHeader("dateString", t('standard.date')),
          textHeader("adskId", "ADSK ID", HeaderSizeEnum.LARGE),
          textHeader("courseName", t('standard.courseName'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("level.name", t('standard.level'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("place", t('standard.place'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("room", t('standard.trainingRoom'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("instructor", t('standard.instructor'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("company", t('standard.company'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("companyPostCode", t('standard.postCode'), HeaderSizeEnum.LARGE),
          textHeader("companyCity", t('standard.place'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("participant", t('standard.courseParticipant'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("email", t('standard.email'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("comments", t('standard.comments'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("invoiceContactPerson", t('standard.invoiceContactPerson'), HeaderSizeEnum.MEDIUM),
          textHeader("invoiceEmail", t('standard.invoiceEmail'), HeaderSizeEnum.MEDIUM),
          textHeader("orderReference", t('standard.invoiceReference'), HeaderSizeEnum.MEDIUM),
          currencyHeader("price.value", t('standard.price'), HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("", "", HeaderSizeEnum.EXTRA_LARGE, {
            renderer: sendRenderer,
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("", "", HeaderSizeEnum.EXTRA_LARGE, {
            renderer: showRenderer,
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),

        ])}
      />}
    {sendCertificate && <SendCertificateDialog
      onClose={closeSendCertificateDialog}
      open={!!sendCertificate}
      sendCertificate={sendCertificate}
    />}
  </>);
}

export default TotalReport;
